import ResourceItem from '@/components/ui/ResourceItem';
import Spacer from '@/components/ui/spacer/spacer';
import React from 'react'
import land_allotment from '@/assets/pdfs/Land Allotment/Details of Nodal persons for land allotment.pdf'
import cn from '@/hooks/class-names';
import { universalLeftRight } from '@/constants/class.config';
import CustomBreadcrumbs from '@/components/ui/header/custom-breadcrumbs';
import useFetchData from '@/hooks/use-fetch-data';

function LandAllotment() {

    const { data, loading, error } = useFetchData("Land Allotment");

    // const data = [
    //     { "_id": 0, "languageKey": "resources.land-allotment.child.01", "url": land_allotment, "target": "_blank" },
    // ]

    return (
        <div>
            <div><CustomBreadcrumbs /></div>
            <div className={cn('bg-primary ', universalLeftRight)}>
                <div className={'grid mobile:grid-cols-2 laptop:grid-cols-4 laptop-large:grid-cols-5 gap-4 laptop:gap-4 laptop-large:gap-10'}>
                    {data?.map((ele, index) => (
                        <div key={index} className="w-full flex flex-col bg-white ">
                            <ResourceItem ele={ele} />
                        </div>
                    ))}
                </div>
            </div>
            <div><Spacer /></div>
        </div>
    )
}

export default LandAllotment;